import { commonViewTexts } from '../common';

const targetName = commonViewTexts.csv;

export const csvListViewTexts = {
  title: `${targetName}一覧`,
  buttons: {
    download: commonViewTexts.download
  },
  searchBarPlaceholder: `${targetName}名`,
  header: {
    name: commonViewTexts.csv
  }
} as const;
